// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Rfl_Y","modalFooterButton":"ModalNotes_modalFooterButton__1vjfw"};